import { Directive, Input, OnChanges, ViewContainerRef } from '@angular/core';

import { MiddleEllipsizeFragmentComponent } from './middle-ellipsize-fragment.component';

@Directive({
  selector: '[appMiddleEllipsize]',
  standalone: false,
})
export class MiddleEllipsizeDirective implements OnChanges {
  @Input('appMiddleEllipsize') text: string;
  @Input() appMiddleEllipsizeTooltip?: string;
  @Input() appMiddleEllipsizeBadge?: string;
  @Input() appMiddleEllipsizeAlign = 'start';
  @Input() appMiddleEllipsizeHideTooltip?: boolean;
  @Input() appMiddleEllipsizeUseHtml?: boolean = false;

  constructor(private viewContainer: ViewContainerRef) {}

  ngOnChanges() {
    this.viewContainer.clear();

    if (this.text) {
      const fragment = this.viewContainer.createComponent(MiddleEllipsizeFragmentComponent);
      fragment.instance.text = this.text;
      fragment.instance.tooltip = this.text;
      fragment.instance.align = this.appMiddleEllipsizeAlign;

      if (this.appMiddleEllipsizeTooltip) {
        fragment.instance.tooltip = this.appMiddleEllipsizeTooltip;
      }

      if (this.appMiddleEllipsizeBadge) {
        fragment.instance.badge = this.appMiddleEllipsizeBadge;
      }
      if (this.appMiddleEllipsizeHideTooltip) {
        fragment.instance.hideTooltip = true;
      }
      if (this.appMiddleEllipsizeUseHtml) {
        fragment.setInput('useHtml', this.appMiddleEllipsizeUseHtml);
      }
    }
  }
}
